import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { firstAllowedPath, hasArea, type PermissionArea } from '../lib/permissions';
import { Spinner } from './ui';

/**
 * Rota kapısı.
 *
 * Bu kapı bir GÜVENLİK sınırı DEĞİLDİR — yalnızca kullanıcıyı erişemeyeceği bir
 * ekranın boş hâline düşürmemek içindir. Asıl kapı her istekte sunucudaki
 * `AreaPermissionGuard`tır ve panel kodunu değiştirmek onu aşmaz.
 */
export function RequireArea({ area, children }: { area: PermissionArea; children: ReactNode }) {
  const { user, verifying } = useAuth();

  // Yerel kopya yokken ve doğrulama sürerken yönlendirme YAPILMAZ: aksi hâlde
  // sayfa her yenilendiğinde bir an /login'e düşülür ve geri gelinir.
  if (!user) {
    return verifying ? <FullPageSpinner /> : <Navigate to="/login" replace />;
  }

  if (!hasArea(user, area)) {
    const fallback = firstAllowedPath(user);
    return fallback ? <Navigate to={fallback} replace /> : <NoAccess />;
  }

  return <>{children}</>;
}

export function FullPageSpinner() {
  return (
    <div className="flex h-full items-center justify-center py-20 text-[var(--c-ink-soft)]">
      <Spinner size={22} />
    </div>
  );
}

export function NoAccess() {
  const { signOut } = useAuth();
  return (
    <div className="mx-auto max-w-md px-6 py-20 text-center">
      <h1 className="text-lg font-semibold">Erişim yetkiniz yok</h1>
      <p className="mt-2 text-sm text-[var(--c-ink-soft)]">
        Hesabınıza hiçbir bölüm için yetki tanımlanmamış. Bir yöneticiden yetki isteyin.
      </p>
      <button
        type="button"
        onClick={() => void signOut()}
        className="mt-5 text-sm text-[var(--c-brand)] underline"
      >
        Çıkış yap
      </button>
    </div>
  );
}
